module.exports = __webpack_public_path__ + "assets/img/favicon/ms-icon-150x150.bf60ca219061db1705806d0a078d437d.png";